export default "__VITE_ASSET__jeEWrurd__"